import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import i18n from '../../../common/i18n';
import Reveal from '../commons/Reveal';
import AnimatedTitle from '../commons/AnimatedTitle';
import AmountSimulator from '../commons/AmountSimulator';
import heroBackground from '../../../../assests/images/help/ayuda_background.svg';
import {
  bodyTextSx,
  HEADER_MOBILE_HEIGHT,
  sectionContentSx,
} from '../style/homeStyles';

const Hero = ({ isMobile }) => (
  <Box
    component="section"
    sx={{
      position: 'relative',
      overflow: 'hidden',
      // Mismo fondo que el hero de Ayuda (degradé rosa -> crema -> blanco).
      backgroundColor: '#FFF5EE',
      backgroundImage: `url(${heroBackground})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      padding: isMobile ? '24px 20px 44px' : '48px 24px 72px',
      textAlign: 'left',
      '@media (max-width:599.95px)': { marginTop: `${HEADER_MOBILE_HEIGHT}px` },
    }}
  >
    {/* Mobile: título y simulador apilados. Desktop: dos columnas.
        Grid propio y no el de MUI: su spacing mete un padding-left que desalinea el título. */}
    <Box sx={{
      ...sectionContentSx,
      position: 'relative',
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
      gap: isMobile ? 0 : '48px',
      alignItems: 'center',
    }}
    >
      <Reveal>
        <AnimatedTitle
          component="h1"
          highlight={i18n.homeHeroTitleHighlight}
          text={i18n.homeHeroTitle}
          fontSize={isMobile ? 36 : 68}
          sx={{ letterSpacing: '-0.03em', lineHeight: 1.05 }}
        />
        <Typography
          component="p"
          sx={{
            ...bodyTextSx,
            marginTop: '14px',
            marginBottom: 0,
            maxWidth: isMobile ? 320 : 460,
            fontSize: isMobile ? 14 : 20,
          }}
        >
          {i18n.homeHeroSubtitle}
        </Typography>
      </Reveal>

      <Reveal delay={120}>
        <AmountSimulator isMobile={isMobile} />
      </Reveal>
    </Box>
  </Box>
);

Hero.propTypes = {
  isMobile: PropTypes.bool,
};

Hero.defaultProps = {
  isMobile: false,
};

export default Hero;
